import { Injectable } from '@angular/core';
import {Jsonp, Http, Headers, URLSearchParams, Response, RequestOptions, RequestMethod } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import { SettingsService } from '../settings/settings.service';
import {Config} from '../../config';
// import {FAQComponent} from '../information/faq/faq.component'
/*
service module for querying information from the Indy.Elections.Service .Net web service
*/
@Injectable()
export class ElectionService {
    // locateServiceURL:string = "http://maps.indy.gov/Indy.LocateAddress.Service2/AjaxGeocode.svc/";
    // private electionServiceURL:string = "http://maps.indy.gov/Indy.Services.Elections/AjaxElections.svc/";
    // private electionServiceURL:string = "http://localhost/Indy.Services.Elections/AjaxElections.svc/";

    // Service Endpoint values
    private electionServiceURL:string;
    private pollingPlaceEndPoint:string =  "PollLocationByXY";
    private satelliteEndPoint:string =  "SatellitePollLocationsByXY";
    private registrationEndPoint:string = 'RegistrationInfo';
    private districtsEndPoint:string = 'DistrictInfoByXY';
    private officialsEndPoint:string = 'ElectedOfficialsByXY';
    private candidatesEndPoint:string = 'CandidatesByXY';
    private publicQuestionsEndPoint:string = 'PublicQuestions';
    private ballotsEndPoint:string = 'BallotsByXY';

    private concatenators:Array<string> = ['and', '&', 'at'];
    private jsonpCallback:string = "?method=JSONP_CALLBACK";
    
    private  searchType:string = "";
    public appSettings: Object;
    public error: any;

    data:Object;

    constructor(private http: Http, private jsonp:Jsonp, private _settingsService: SettingsService){
        this.appSettings = Config.config[0];
        this.electionServiceURL = this.appSettings["electionServiceURL"];


        // // Get app settings from settings service
        // this._settingsService.getAppSettings().subscribe(
        //     settings => {
        //         this.appSettings = settings[0]
        //         this.electionServiceURL = this.appSettings["electionServiceURL"];
        //     },
        //     err => { this.error = true }
        // );
    }

    //Web Service call to get the location and supporting information about the polling place based upon the XY coordinates of the voters address location
    getPollLocation(x, y):any {
        
        let urlEndpoint:string = this.electionServiceURL + this.pollingPlaceEndPoint + '/' + x + '/' + y + this.jsonpCallback;

        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    //Web Service call to get the satellite voting locations
    getSatellites(x, y):any {

        let urlEndpoint:string = this.electionServiceURL + this.satelliteEndPoint + '/' + x + '/' + y + this.jsonpCallback;

        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    //Web service call to get the voters registration info
    getRegistrationInfo (houseNum,birthdate):any {

        let urlEndpoint:string = this.electionServiceURL + this.registrationEndPoint + '/' + houseNum + '/' + birthdate + this.jsonpCallback;

        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
            
    }

        //Web service call to get the voters registration info
    getDistricts (x,y):any {
        let urlEndpoint:string = this.electionServiceURL + this.districtsEndPoint + '/' + x + '/' + y + this.jsonpCallback;
        
        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    //web service call to get elected officicals for location
    getOfficials(x,y):any {
        let urlEndpoint:string = this.electionServiceURL + this.officialsEndPoint + '/' + x + '/' + y + '/ALL' + this.jsonpCallback;
        
        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    //Get the list of candidates
    getCandidates (x,y):any {

        let urlEndpoint:string = this.electionServiceURL + this.candidatesEndPoint + '/' + x + '/' + y + this.jsonpCallback;
        
        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }
    
    //Get the public questions
    getPublicQuestions ():any {

        let urlEndpoint:string = this.electionServiceURL + this.publicQuestionsEndPoint + this.jsonpCallback;
        
        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }
    
    //Web service call to get the ballot info
    getBallots (x,y,urlPathPrefix,fileExt):any {
        let urlEndpoint:string = this.electionServiceURL + this.ballotsEndPoint + '/' + x + '/' + y + this.jsonpCallback + '&urlPathPrefix=' + urlPathPrefix + '&fileExt=' + fileExt;
        
        return this.jsonp.get(urlEndpoint)
            .toPromise()
            .then(
                (response) => response.json()
            ).catch(this.handleError);
    }

    getFAQs (language):any {
        let urlEndpoint:string; 
        
        //determine which set of questions to load
        switch (language) {

            case "en":
                  urlEndpoint = "data/faq_en.json"; // + this.jsonpCallback;
                  break;

            case "es":
                  urlEndpoint = "data/faq_es.json"; // + this.jsonpCallback;
                break;

        }

        return this.http.get(urlEndpoint).map((res:Response) => res.json());

        
    }

    sharePPViaEmail (msgBody:Object): Promise<boolean> {

        let urlEndpoint:string = this.appSettings["emailService"] + this.jsonpCallback;
 

        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this.http.post(urlEndpoint, msgBody, options)
                        .toPromise()
                        .then(
                            (response) => response.json()
                        )
                        .catch(this.handleError);

    }
    
    private notifyResult(res: Response) {
        let body = res.json();
        return body.data || { };
    }
    
    //handle any errors
    private handleError(error: any) {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }


    // checkIfLinkIsAlive(){
    //     return this.http.request(new Request({
    //         method: RequestMethod.Get,
    //         url: "http://gistv09/Ballots/190507_00057_DEM.pdf"
    //     }));

    //     this.http.request("http://gistv09/Ballots/190507_00057_DEM.pdf").map((res:Response) => {
    //         res.toString();
    //     });
    // }
}


// WEBPACK FOOTER //
// ./app/shared/election-service/election.service.ts